import { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Undo2, XCircle } from 'lucide-react';
import { AuthContext } from '../contexts/AuthContext';
import './ArtistRequestAlerts.css';

const API = 'https://apem.riderup.uk/api/artist-request-notifications';

export default function ArtistRequestAlerts() {
    const { userToken } = useContext(AuthContext);
    const [alerts, setAlerts] = useState([]);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const dialog = useRef(null);
    const ok = useRef(null);
    const acknowledged = useRef(new Set());
    const current = alerts[0];
    const currentId = current?.id;
    useEffect(() => {
        setAlerts([]); setError('');
        acknowledged.current.clear();
        if (!userToken) return;
        let active = true;
        let pending = false;
        const poll = async () => {
            if (!active || pending || document.hidden) return;
            pending = true;
            try {
                const response = await axios.get(API, { headers: { Authorization: `Bearer ${userToken}` } });
                if (active) setAlerts((response.data.data || []).filter(item => !acknowledged.current.has(item.id)));
            } catch { /* Keep unread decisions available until connectivity returns. */ }
            finally { pending = false; }
        };
        void poll(); const timer = setInterval(poll, 5000);
        document.addEventListener('visibilitychange', poll);
        return () => { active = false; clearInterval(timer); document.removeEventListener('visibilitychange', poll); };
    }, [userToken]);
    useEffect(() => {
        if (!currentId || !dialog.current) return;
        const element = dialog.current;
        const previous = document.activeElement;
        element.showModal(); ok.current?.focus();
        return () => { element.close(); previous?.focus?.(); };
    }, [currentId]);
    const acknowledge = async () => {
        if (!current || busy) return;
        setBusy(true); setError('');
        try {
            await axios.post(`${API}/${current.id}/read`, {}, { headers: { Authorization: `Bearer ${userToken}` } });
            acknowledged.current.add(current.id);
            setAlerts(previous => previous.filter(item => item.id !== current.id));
        } catch { setError('Não foi possível confirmar o aviso. Tente novamente.'); }
        finally { setBusy(false); }
    };
    if (!current) return null;
    const Icon = current.event === 'accepted' ? CheckCircle2 : current.event === 'refund_completed' ? Undo2 : XCircle;
    return <dialog ref={dialog} className="artist-request-alert" aria-labelledby="artist-alert-title" aria-describedby="artist-alert-body" onCancel={event => { event.preventDefault(); void acknowledge(); }}>
        <Icon size={32} className={current.event === 'rejected' ? 'artist-alert-rejected' : 'artist-alert-accepted'} />
        <h2 id="artist-alert-title">{current.title}</h2><p id="artist-alert-body">{current.body}</p>
        {error && <p role="alert">{error}</p>}<button ref={ok} disabled={busy} onClick={acknowledge}>{busy ? 'Confirmando...' : 'OK'}</button>
    </dialog>;
}
